export default __webpack_public_path__ + "static/media/delete.6e968884.svg";